export default __webpack_public_path__ + "NY_logo_en.598ffd7f.svg";